import styled from 'styled-components';
export const Background = styled.div `
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: -100px;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 9999;
`;
export const Container = styled.div `
    max-width: min(80vw, 375px);
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.secondary};
    border-radius: 1rem;
    padding: 1rem;
`;
export const HeaderContainer = styled.div `
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
`;
export const CloseIconContainer = styled.div `
    cursor: pointer;
    height: 24px;
    width: 24px;
    background-color: ${(props) => props.theme.primary};
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    text-align: center;
    display: flex;
`;
